import React from 'react';
import { Grid3x3, List } from 'lucide-react';

const ViewToggle = ({ viewMode, setViewMode }) => {
  return (
    <div className="view-toggle-desktop">
      <button
        className={`view-btn ${viewMode === "card" ? "active" : ""}`}
        onClick={() => {
          localStorage.setItem("vehiclesViewMode", "card");
          setViewMode("card");
        }}
      >
        <Grid3x3
          size={24}
          color={viewMode === "card" ? "#e6c618" : "#666"}
        />
      </button>
      <button
        className={`view-btn ${viewMode === "row" ? "active" : ""}`}
        onClick={() => {
          localStorage.setItem("vehiclesViewMode", "row");
          setViewMode("row");
        }}
      >
        <List size={24} color={viewMode === "row" ? "#e6c618" : "#666"} />
      </button>
    </div>
  );
};

export default ViewToggle;